import { render, staticRenderFns } from "./PropertyIncident.vue?vue&type=template&id=3f47918d"
import script from "./PropertyIncident.vue?vue&type=script&lang=ts"
export * from "./PropertyIncident.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports